import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=7c841036&scoped=true&"
import script from "./AdminList.vue?vue&type=script&lang=js&"
export * from "./AdminList.vue?vue&type=script&lang=js&"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=7c841036&prod&lang=scss&scoped=true&"
import style1 from "./AdminList.vue?vue&type=style&index=1&id=7c841036&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c841036",
  null
  
)

export default component.exports